import axiosInstance from "../axiosInstance";
import { useCallback } from "react";
import { FluxModel } from "../Routes/Home/Components/ADS/constant";

const usePostProduct = () => {
  const fillFormData = ({
    projectId,
    form,
    formData,
    isExternalModel,
    isIdeogramModel,
    supportsAspectRatio,
    selectedImageUrl,
  }) => {
    const {
      model,
      categoryId,
      prompt,
      negativePrompt,
      keepStructure,
      // styleType,
      // colorPalette,
      imageInputFile,
      aspectRatio,
    } = form;

    formData.append("modelName", model);
    formData.append("projectId", projectId);

    if (isExternalModel) {
      formData.append("prompt", prompt);

      // handle flux kontext params
      if (form.model === FluxModel.FluxKontext) {
        if (imageInputFile) {
          formData.append("imageInputFile", imageInputFile);
        }

        if (form.selectedImageUrl) {
          formData.append("selectedImageUrl", selectedImageUrl);
        }
      }

      if (supportsAspectRatio && aspectRatio) {
        formData.append("aspectRatio", aspectRatio);
      }

      // handle ideogramModel optional params
      // if (isIdeogramModel) {
      //   if (!!styleType) {
      //     formData.append("styleType", styleType);
      //   }

      //   if (!!colorPalette) {
      //     formData.append("colorPalette", colorPalette);
      //   }
      // }
      return;
    }

    // internal model (WeddinglyModel)
    formData.append("prompt", prompt);
    formData.append("categoryId", categoryId);
    formData.append("negativePrompt", negativePrompt);
    formData.append("keepStructure", keepStructure);

    if (keepStructure && selectedImageUrl) {
      formData.append("selectedImageUrl", selectedImageUrl);
    }
  };

  return useCallback(
    ({
      projectId,
      form,
      isExternalModel,
      isIdeogramModel,
      supportsAspectRatio,
      selectedImageUrl,
    }) => {
      const baseUrl = window.localStorage.getItem("BaseURL");
      const endpoint = "/services/projectmanagement/api/products";
      const fullUrl = baseUrl + endpoint;

      const formData = new FormData();
      fillFormData({
        projectId,
        form,
        formData,
        isExternalModel,
        isIdeogramModel,
        supportsAspectRatio,
        selectedImageUrl,
      });

      return new Promise((resolve, reject) => {
        axiosInstance
          .post(fullUrl, formData)
          .then((res) => resolve(res.data))
          .catch(reject);
      });
    },
    [],
  );
};

export default usePostProduct;
